import React from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header2 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader";
import Breadcrumb from "../components/breadcrumb";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import SignIn from "../components/signin/login";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import { useState } from "react";
import { Link } from "react-router-dom";

function Login(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>UKICNEWS - Login | We are your go-to source for the latest UK Immigration News</title>
          <meta
            name="description"
            content="Stay updated with the latest UK immigration news, visa changes, sponsorship jobs, and clear policy explanation for Business, Family Sponsorship, study, work, visit, ILR and more. UKICNEWS delivers trusted and timely immigration updates."
          />
          <link rel="canonical" href="https://www.ukicnews.com/login" />

          {/* Open Graph (Facebook / LinkedIn preview) */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="UKICNEWS | Login" />
          <meta
            property="og:description"
            content="Get reliable UK immigration updates, visa news, and sponsorship job opportunities."
          />
          <meta property="og:url" content="https://www.ukicnews.com/login" />
          <meta property="og:image" content="https://www.ukicnews.com/preview.png" />

          {/* Twitter preview */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="UKICNEWS | Login" />
          <meta
            name="twitter:description"
            content="Stay updated with UK immigration rules and sponsorship jobs."
          />
          <meta name="twitter:image" content="https://www.ukicnews.com/preview.png" />
        </Helmet>
      </HelmetProvider>
      <MobileHeader handleMobile={handleMobile} />
      <Header2 clname="actPage9" handleMobile={handleMobile} />
      <Breadcrumb title="Login" />
      <SignIn />
      <Footer />
      <Gotop />
    </>
  );
}

export default Login;
